import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Formik } from "formik";
import { AddPhraseSchema } from "./validator.js";
import { Box, Stack } from "@mui/material";

const AddPhrase = ({ value, onSave }) => {
    const initialValues = {
        phrase: value
    }

    /**
     * Submit Method to save a phrases
     */
    const submitForm = async (values, { setSubmitting }) => {
        onSave(values.phrase.trim() || "");
        setSubmitting(false);
    };

    return (
        <Formik
            enableReinitialize
            validationSchema={AddPhraseSchema}
            initialValues={initialValues}
            onSubmit={(values, actions) => {
                submitForm(values, actions);
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
                isSubmitting,
            }) => (
                <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                >
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="start"
                        gap={2}
                    >
                        <TextField
                            fullWidth
                            size="small"
                            multiline={true}
                            variant="outlined"
                            label="Phrase"
                            required
                            name={"phrase"}
                            value={values.phrase}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.phrase && !!errors.phrase}
                            helperText={touched.phrase ? errors.phrase : ''}
                        />
                        <Button
                            variant="contained"
                            type="submit"
                            disabled={isSubmitting || true} // VOC-199 DISABLED FOR DEMO
                        >
                            Done
                        </Button>
                    </Stack>
                </Box>
            )}
        </Formik>
    );
}

export default AddPhrase;